// Note: Journey Bar Steps  - A local template for development purposes only
export const GetLocalJourneyBarStepsSnP = () => {
    return [
        {
            position: 1, // Posiotion of the step in journey bar                    (Note: Backend doesn't have to pass. Can just set '0' as default))
            name: 'CampaignBrief', // Unique name. Use name not id as these come from cust admin eventually
            title: window.translate('Campaign Brief'),
            enabled: true, // For enabling/disabling                                (Note: Backend doesn't have to pass. Can just set 'false' as default)
            hidden: false, // To hide/display                                       (Note: Backend doesn't have to pass. Can just set 'false' as default)
            currentStep: true, // Sets to true if it's current step                 (Note: Backend doesn't have to pass. Can just set 'false' as default)
            isFirst: true, // To determine if the step is first step                (Note: Backend doesn't have to pass. Can just set 'false' as default)
            isLast: false, // To determine if the step is last step                 (Note: Backend doesn't have to pass. Can just set 'false' as default)
            stepEdited: false, // Sets to true if at least one field is filled      (Note: Backend doesn't have to pass. Can just set 'false' as default)
            stepCompleted: false, // Sets to true if all mandatory fields are filled (Note: Backend doesn't have to pass. Can just set 'false' as default)
            requiredSteps: JSON.stringify([]), // To determine if the step can be enabled or not
            alternateRequiredSteps: JSON.stringify([]) // To determine if the step can be enabled or not - This is required as some steps could be enabled from multiple criteria
        },
        {
            position: 2,
            name: 'OffAirCosts',
            title: window.translate('Off-Air Costs'),
            enabled: false,
            hidden: false,
            currentStep: false,
            isFirst: false,
            isLast: false,
            stepEdited: false,
            stepCompleted: false,
            requiredSteps: JSON.stringify([]),
            alternateRequiredSteps: JSON.stringify([])
        },
        {
            position: 3,
            name: 'BespokeBilling',
            title: window.translate('Bespoke Billing'),
            enabled: false,
            hidden: false,
            currentStep: false,
            isFirst: false,
            isLast: false,
            stepEdited: false,
            stepCompleted: false,
            requiredSteps: JSON.stringify([]),
            alternateRequiredSteps: JSON.stringify([])
        },
        {
            position: 4,
            name: 'QuoteBooking',
            title: window.translate('Quote & Booking'),
            enabled: false,
            hidden: false,
            currentStep: false,
            isFirst: false,
            isLast: false,
            stepEdited: false,
            stepCompleted: false,
            requiredSteps: JSON.stringify(['CampaignBrief']),
            alternateRequiredSteps: JSON.stringify([])
        },
        {
            position: 5,
            name: 'AirtimeSettings',
            title: window.translate('Airtime Bursts'),
            enabled: false,
            hidden: false,
            currentStep: false,
            isFirst: false,
            isLast: false,
            stepEdited: false,
            stepCompleted: false,
            requiredSteps: JSON.stringify(['QuoteBooking']),
            alternateRequiredSteps: JSON.stringify([])
        },
        {
            position: 6,
            name: 'TransmissionTimes',
            title: window.translate('Transmission Times'),
            enabled: false,
            hidden: false,
            currentStep: false,
            isFirst: false,
            isLast: false,
            stepEdited: false,
            stepCompleted: false,
            requiredSteps: JSON.stringify(['QuoteBooking']),
            alternateRequiredSteps: JSON.stringify([])
        },
        {
            position: 7,
            name: 'Billing',
            title: window.translate('Billing'),
            enabled: false,
            hidden: false,
            currentStep: false,
            stepEdited: false,
            stepCompleted: false,
            requiredSteps: JSON.stringify(['QuoteBooking']),
            alternateRequiredSteps: JSON.stringify([])
        },
        {
            position: 8,
            name: 'Performance',
            title: window.translate('Performance/PCA'),
            enabled: false,
            hidden: false,
            currentStep: false,
            isFirst: false,
            isLast: true,
            stepEdited: false,
            stepCompleted: false,
            requiredSteps: JSON.stringify([]),
            alternateRequiredSteps: JSON.stringify([])
        }
    ];
};
